import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=541af664"
import script from "./StatisticsCard.vue?vue&type=script&lang=js"
export * from "./StatisticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports